<template>
  <Suspense>
    <template #default>
      <login />
    </template>
    <template #fallback> 読み込み中... </template>
    <template #error> エラー </template>
  </Suspense>
</template>

<script>
import { defineComponent } from "vue";
import Login from "../components/LoginActions.vue";

export default defineComponent({
  components: {
    Login,
  },
});
</script>
